import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface PlayPauseIconProps {
  isPlaying: boolean;
  size?: number;
}

const PlayPauseIcon = ({ isPlaying, size = 40 }: PlayPauseIconProps) => {
  if (isPlaying) {
    // Pause icon
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 4H6V20H10V4ZM18 4H14V20H18V4Z" fill="currentColor" />
      </svg>
    );
  }
  // Play icon
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
    </svg>
  );
};

export default PlayPauseIcon;
